module.exports = __webpack_public_path__ + "img/vertical_3_6_7005.ffdf7679.png";